import { render, staticRenderFns } from "./ConfirmedView.vue?vue&type=template&id=779f591f"
import script from "./ConfirmedView.vue?vue&type=script&lang=js"
export * from "./ConfirmedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports